// Toast stack — neither kit ships one. Styles in public/styles/main.css.
import { createContext, useCallback, useContext, useState, type ReactNode } from 'react';

interface ToastItem { id: number; kind: 'ok' | 'warn' | 'err'; text: string }

const ToastCtx = createContext<{ toast: (kind: ToastItem['kind'], text: string) => void }>({ toast: () => {} });

let nextId = 1;

export function ToastProvider({ children }: { children: ReactNode }) {
  const [items, setItems] = useState<ToastItem[]>([]);

  const toast = useCallback((kind: ToastItem['kind'], text: string) => {
    const id = nextId++;
    setItems((prev) => [...prev, { id, kind, text }]);
    // An error stays twice as long: it is the one the operator has to read.
    setTimeout(() => setItems((prev) => prev.filter((t) => t.id !== id)), kind === 'err' ? 8000 : 4000);
  }, []);

  return (
    <ToastCtx.Provider value={{ toast }}>
      {children}
      <div className="toast-stack">
        {items.map((t) => (
          <div key={t.id} className={`toast toast-${t.kind}`} role={t.kind === 'err' ? 'alert' : 'status'}>{t.text}</div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx).toast;
